export default class CollisionController {
  constructor({ game, debug }) {
    this.game = game;

    if (debug) {
      this.debugger = this.game.make.graphics();
    }
  }

  clearDebugger() {
    if (this.debugger) {
      this.debugger.clear();
    }
  }

  checkCollisions(target, group) {
    this.clearDebugger();
    const charBounds = target.getWorldBounds();
    this.renderBounds(charBounds, false);
    const colliding = group.reduce((arr, item) => {
      const itemBounds = item.getWorldBounds();
      if (charBounds.intersects(itemBounds)) {
        this.renderBounds(itemBounds, true);
        arr.push(item);
      } else {
        this.renderBounds(itemBounds, false);
      }

      return arr;
    }, []);
    return colliding;
  }

  renderBounds(bounds, collision) {
    if (this.debugger) {
      this.debugger.lineStyle(3, collision ? 0xff0000 : 0xffff00);
      this.debugger.beginFill(collision ? 0xff0000 : 0xffff00, 0.25);
      this.debugger.drawRect(bounds.x, bounds.y, bounds.width, bounds.height);
    }
  }
}
